<template>
  <div v-if="apps.length">
    <div class="col-lg-12">
      <NavBarActions @canceledOrder="canceledOrder" :titulo="'Editar Pedido'" :notaFiscal="notaFiscal" :order="order"
        :toggleLoadingActionsV="toggleLoadingActionsV" />
      <b-row>
        <b-col class="text-left">
          <b-button variant="dark" size="sm" @click="closeEdit()">
            <i class="fa fa-arrow-left"></i>
          </b-button>
          <b-button variant="primary" size="sm" @click="save" ref="sv_order">
            <i class="fa fa-check"></i>
            Salvar alterações
          </b-button>
        </b-col>
        <b-col class="text-right">
          <b> Status do pedido:</b>
          <b-badge variant="info">
            <small>{{ order_v2.status }}</small>
          </b-badge>
          <br />
          <b>Data da compra:</b> {{ order_v2.created }}
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <StepsStatus :id="order_v2.id" :currentStatus="order_v2.before_status" />
        </b-col>
      </b-row>

      <div>
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">{{ $t("Dados Faturamento") }}</h3>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="input-group">
                      <label for="name">{{ $t("Nome") }}:</label>
                      <input class="form-control" v-model="orderClone.payer_name" />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group">
                      <label for="lastname">{{ $t("Sobrenome") }}:</label>
                      <input class="form-control" v-model="orderClone.payer_lastname" />
                    </div>
                  </div>
                </div>

                <div class="row my-4"></div>

                <div class="form-group">
                  <div class="form-group">
                    <label for="payer_address">{{ $t("Endereço") }}:</label>
                    <b-form-input v-model="orderClone.payer_address"></b-form-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">
                    <div class="input-group">
                      <label for="payer_address_number">{{ $t("Nº") }}:</label>
                      <input class="form-control" v-model="orderClone.payer_address_number" />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group">
                      <label for="payer_address_complement">{{ $t("Complemento") }}:</label>
                      <input class="form-control" v-model="orderClone.payer_address_complement" />
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="input-group">
                      <label for="payer_neighborhood">{{ $t("Bairro") }}:</label>
                      <input class="form-control" v-model="orderClone.payer_neighborhood" />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group">
                      <label for="payer_city">{{ $t("Cidade") }}:</label>
                      <input class="form-control" v-model="orderClone.payer_city" />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group">
                      <label for="payer_state">{{ $t("Estado") }}:</label>
                      <input class="form-control" v-model="orderClone.payer_state" />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group">
                      <label for="payer_country">{{ $t("País") }}:</label>
                      <input class="form-control" v-model="orderClone.payer_country" />
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="payer_zipcode">{{ $t("CEP") }}:</label>
                  <b-form-input v-model="orderClone.payer_zipcode" v-mask="'#####-###'"></b-form-input>
                </div>

                <div class="row my-4"></div>

                <div class="form-group">
                  <label for="payer_email">Email:</label>
                  <b-form-input v-model="orderClone.payer_email" type="email"></b-form-input>
                </div>

                <div class="form-group">
                  <div class="row">
                    <div class="col-3">
                      <div class="form-group">
                        <label for="telefone">{{ $t("DDD") }}:</label>
                        <b-form-input v-model="orderClone.payer_phone_area" v-mask="['##']"></b-form-input>
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="form-group">
                        <label for="telefone">{{ $t("Telefone") }}:</label>
                        <b-form-input v-model="orderClone.payer_phone"
                          v-mask="['####-####', '#####-####']"></b-form-input>
                      </div>
                    </div>

                    <div class="col-3">
                      <div class="form-group">
                        <label for="telefone">{{ $t("DDD 2") }}:</label>
                        <b-form-input v-model="orderClone.payer_phone2_area" v-mask="['##']"></b-form-input>
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="form-group">
                        <label for="telefone">{{ $t("Telefone 2") }}:</label>
                        <b-form-input v-model="orderClone.payer_phone2"
                          v-mask="['####-####', '#####-####']"></b-form-input>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row my-4"></div>

                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="input-group">
                        <label for="cpf">{{ $t("CPF") }}:</label>
                        <input class="form-control" v-model="orderClone.payer_cpf" v-mask="'###.###.###-##'" />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="input-group">
                        <label for="cnpj">{{ $t("CNPJ") }}:</label>
                        <input class="form-control" v-model="orderClone.payer_cnpj" v-mask="'XX.XXX.XXX/XXXX-XX'" />
                      </div>
                    </div>

                    <div class="col-12 col-lg-6" v-if="orderClone.payer_cnpj">
                      <div class="input-group">
                        <label for="razao_social">{{ $t("Razão Social") }}:</label>
                        <input id="razao_social" v-if="orderClone.payer_razao_social" class="form-control" v-model="orderClone.payer_razao_social" />
                        <input id="razao_social" v-else class="form-control" v-model="orderClone.payer_company_name" />
                      </div>
                    </div>

                    <div class="col-12 col-lg-6" v-if="orderClone.payer_cnpj">
                      <div class="input-group">
                        <label for="payer_ie">{{ $t("Inscrição Estadual") }}:</label>
                        <input id="payer_id" class="form-control" v-model="orderClone.payer_tax_id" />
                        <!--<input v-if="orderClone.payer_tax_id" id="payer_id" class="form-control"
                          v-model="orderClone.payer_tax_id" />
                        <input v-else id="payer_id" class="form-control" v-model="orderClone.payer_cnpj" />-->
                      </div>
                    </div>

                  </div>
                </div>

                <div class="row my-4"></div>

                <div class="form-group">
                  <label for="payer_additional_info">{{ $t("Informações Adicionais") }}:</label>
                  <b-form-input v-model="orderClone.payer_additional_info"></b-form-input>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-sm-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">
                  {{
                    showAddressShipping ? $t("Dados do endereço") : $t("Dados de Entrega")
                  }}
                </h3>
                <div class="card-options">
                  <b-button size="sm" class="ml-2" :variant="!showAddressShipping ? 'primary' : 'secondary'"
                    @click="showAddressShipping = !showAddressShipping">
                    {{
                      !showAddressShipping
                      ? $t("Ver Endereço")
                      : $t("Ver Dados de Entrega")
                    }}
                  </b-button>
                </div>
              </div>
              <div class="card-body">
                <div v-if="showAddressShipping">
                  <div class="row">
                    <div class="col-12 col-lg-6">
                      <div class="form-group">
                        <label for="receiver_name">{{ $t("Nome") }}:</label>
                        <b-form-input v-model="orderClone.receiver_name"></b-form-input>
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="form-group">
                        <label for="receiver_lastname">{{ $t("Sobrenome") }}:</label>
                        <b-form-input v-model="orderClone.receiver_lastname"></b-form-input>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="receiver_address">{{ $t("Endereço") }}:</label>
                    <b-form-input v-model="orderClone.receiver_address"></b-form-input>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <div class="input-group">
                        <label for="receiver_address_number">{{ $t("Nº") }}:</label>
                        <b-form-input v-model="orderClone.receiver_address_number"></b-form-input>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="input-group">
                        <label for="receiver_address_complement">{{ $t("Complemento") }}:</label>
                        <b-form-input v-model="orderClone.receiver_address_complement"></b-form-input>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <div class="input-group">
                        <label for="receiver_neighborhood">{{ $t("Bairro") }}:</label>
                        <b-form-input v-model="orderClone.receiver_neighborhood"></b-form-input>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="input-group">
                        <label for="receiver_city">{{ $t("Cidade") }}:</label>
                        <b-form-input v-model="orderClone.receiver_city"></b-form-input>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <div class="input-group">
                        <label for="payer_state">{{ $t("Estado") }}:</label>
                        <b-form-input v-model="orderClone.receiver_state"></b-form-input>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="input-group">
                        <label for="receiver_country">{{ $t("País") }}:</label>
                        <b-form-input v-model="orderClone.receiver_country"></b-form-input>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="receiver_zipcode">{{ $t("CEP") }}:</label>
                    <b-form-input v-model="orderClone.receiver_zipcode" v-mask="'#####-###'"></b-form-input>
                  </div>

                  <div class="form-group">
                    <label for="receiver_email">Email:</label>
                    <b-form-input v-model="orderClone.receiver_email" type="email"></b-form-input>
                  </div>

                  <div class="row">
                    <div class="col-3">
                      <div class="form-group">
                        <label for="telefone">{{ $t("DDD") }}:</label>
                        <b-form-input v-model="orderClone.receiver_phone_area" v-mask="['##']"></b-form-input>
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="form-group">
                        <label for="telefone">{{ $t("Telefone") }}:</label>
                        <b-form-input v-model="orderClone.receiver_phone"
                          v-mask="['####-####', '#####-####']"></b-form-input>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="!showAddressShipping">
                  <hr class="dropdown-divider" />

                  <order-shipments :item="order_v2" :order="order" :shipment="shipment"
                    v-for="(shipment, index) in order.shipments" v-bind:key="shipment.id" :shipmentkey="shipment.id"
                    :shipmentIndex="index" :status="order_v2.status" :hasPermissionToEdit="hasPermissionToEdit"
                    :tags="order_v2.tags"></order-shipments>

                  <p class="text-right" v-if="order_v2.status != 'Entregue' && order_v2.status != 'Em Transito'
                    ">
                    <b-button variant="success" @click="addNewShipping">
                      <i class="fa fa-plus"></i>
                      {{ $t("Criar nova entrega") }}
                    </b-button>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <b-col sm="12">
            <b-card header="Itens do pedido" header-tag="header" no-body>
              <!--<b-table striped hover :items="order.items" :fields="fields"></b-table>-->
              <div class="items-table-wrapper">
                <table class="table b-table table-striped table-hover items-table">
                  <thead class>
                    <tr>
                      <th>{{ $t("SKU") }}</th>
                      <th v-if="stock_code_show">{{ $t("Tabela de estoque") }}</th>
                      <th v-if="place_code_show">{{ $t("Código Places") }}</th>
                      <th>{{ $t("Nome") }}</th>
                      <th>{{ $t("Preço") }}</th>
                      <th>{{ $t("Quantidade") }}</th>
                      <th>{{ $t("Desconto") }}</th>
                      <th>{{ $t("Comissão") }}</th>
                      <th>{{ $t("Imposto") }}</th>
                      <th>{{ $t("Total") }}</th>
                      <th v-if="order.status == 'pending' || order.status == 'approved'"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index_item) in order.items" v-bind:key="item.id">
                      <td>
                        <template v-if="!editingItems[itemKey(item)]">
                          <span>{{ item.sku }}</span>
                          <span v-if="item.original_sku">
                            <small>({{ item.original_sku }})</small>
                          </span>
                          <span v-if="item.variation && item.variation.sku">&nbsp;- {{ item.variation.sku }}</span>
                        </template>
                        <template v-else>
                          <div class="sku-edit-grid" :class="{ single: !(item.variation && item.variation.sku) }">
                            <div class="sku-edit-field">
                              <small class="text-muted d-block mb-1">{{ $t('SKU') }}</small>
                              <input class="form-control" v-model="editingItems[itemKey(item)].sku" :placeholder="$t('SKU')" />
                            </div>

                            <div v-if="item.variation && item.variation.sku" class="sku-edit-field">
                              <small class="text-muted d-block mb-1">{{ $t('SKU Variação') }}</small>
                              <input
                                class="form-control"
                                v-model="editingItems[itemKey(item)].variation_sku"
                                :placeholder="$t('SKU Variação')"
                              />
                            </div>
                          </div>
                        </template>
                      </td>
                      <td v-if="item.stock_code">{{ stockCodeShow(item.stock_code) }}</td>
                      <td v-if="item.place_code">{{ placeCodeShow(item.place_code) }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ formatCurrency(item.price, locale) }}</td>
                      <td>{{ item.quantity }}</td>
                      <td>{{ formatCurrency(item.discount, locale) }}</td>
                      <td>
                        {{ formatCurrency(item.commission.total_charged, locale) }}
                        <b-badge pill variant="success">{{ item.commission.tax }}%</b-badge>
                      </td>
                      <td>{{ formatCurrency(item.tax ? item.tax : 0, locale) }}</td>
                      <td>{{ formatCurrency(item.total, locale) }}</td>
                      <td v-if="order.status == 'pending' || order.status == 'approved'">
                        <b-button
                          v-if="!editingItems[itemKey(item)]"
                          @click="editItem(item)"
                          style="margin-top: 0 !important"
                          size="sm"
                          variant="edit"
                          v-b-tooltip.hover
                          v-b-tooltip="$t('Trocar SKU')"
                        >
                          <i class="fas fa-pencil-alt"></i>
                        </b-button>
                        <b-button
                          v-else
                          @click="saveEditItem(item)"
                          style="margin-top: 0 !important"
                          size="sm"
                          variant="edit"
                          v-b-tooltip.hover
                          v-b-tooltip="$t('Salvar item')"
                        >
                          <i class="fas fa-save"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <b-button v-if="order.items.length <= 0" slot="footer" size="sm" variant="success" v-b-modal.modalPrevent>{{
                $t("Adicionar novo") }}</b-button>
            </b-card>
          </b-col>

          <div class="col-md-4 col-sm-6">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">{{ $t("Dados Adicionais") }}</h3>
              </div>
              <div class="card-body">
                <div v-if="orderClone.delivery_type">
                  <b>{{ $t("Tipo de Entrega") }}:</b>
                  {{ orderClone.delivery_type }}
                </div>

                <div
                  v-if="
                    orderClone.shipments.length > 0 && orderClone.shipments[0]
                  "
                >
                  <b>{{ $t("Data estimada de entrega") }}:</b>
                  {{
                    formatDateDelivery(
                      orderClone.shipments[0].estimate_delivery_date,
                      locale
                    )
                  }}
                  <div v-if="orderClone.shipments[0].expected_collection_date">
                    <b>{{ $t("Data prevista de coleta") }}:</b>
                    {{
                      formatDateDelivery(
                        orderClone.shipments[0].expected_collection_date,
                      locale
                    )
                  }}
                  </div>
                </div>

                <div v-if="orderClone.expected_delivery_date">
                  <b>{{ $t("Data estimada de envio") }}:</b>
                  {{ formatDateDelivery(orderClone.expected_delivery_date, locale) }}
                </div>

                <div v-if="orderClone.expected_send_date">
                  <b>{{ $t("Data limite para envios") }}:</b>
                  {{ formatDateDelivery(orderClone.expected_send_date, locale, true) }}
                </div>

                <div class="mt-3">
                  <b>{{ $t("Plugg ID") }}:</b>
                  {{ orderClone.id }}
                </div>

                <div v-for="availableIn in orderClone.available" v-bind:key="availableIn" class="mt-3">
                  {{ availableIn }}
                </div>

                <div v-if="orderClone.external" class="mt-3">
                  <b>IDs Externos</b>
                  <br />
                  <div v-for="(value, key) in orderClone.external" v-bind:key="value">
                    <b>{{ getAppNameByClientID(key) }}</b>: {{ value }}
                  </div>
                </div>

                <div v-if="orderClone.commission.total_charged != null" class="mt-3">
                  <b>Comissões</b>
                  <br />
                  {{ orderClone.commission.total_charged }}
                  <b-badge pill variant="success">{{ orderClone.commission.tax }}%</b-badge>
                </div>

                <div v-if="hasBuffered()" class="mt-3" >
                    <b>Disponibilidade</b>
                    <br />
                    Previsão de liberação: {{ getDateBuffered() }}
                </div>

              </div>
            </div>
          </div>

          <div class="col-md-4 col-sm-6">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">{{ $t("Dados de pagamento") }}</h3>
              </div>
              <div class="card-body log_history">
                <div v-if="orderClone.payments.length > 0">
                  <b-list-group v-for="payment in orderClone.payments" :key="payment._id">
                    <b-list-group-item>
                      <span class="message">
                        <b>{{ $t("Total") }}:</b>
                        {{ formatCurrency(payment.payment_total, locale) }}
                      </span>
                      <span class="message" v-if="payment.payment_interest">
                        <b>{{ $t("Total de Juros") }}:</b>
                        {{ formatCurrency(payment.payment_interest, locale) }}
                      </span>
                      <span class="message" v-if="payment.payment_card_brand">
                        <b>{{ $t("Bandeira") }}:</b>
                        {{ capitalizeFirstLetter(payment.payment_card_brand) }}
                      </span>
                      <span class="message">
                        <b>{{ $t("Método") }}:</b>
                        {{ capitalizeFirstLetter(payment.payment_method) }}
                      </span>
                      <span class="message">
                        <b>{{ $t("Tipo") }}:</b>
                        {{ capitalizeFirstLetter(payment.payment_type) }}
                      </span>
                      <span class="message" v-if="payment.payment_installments">
                        <b>{{ $t("Número de parcelas") }}:</b>
                        {{ payment.payment_installments }}
                      </span>
                    </b-list-group-item>
                  </b-list-group>
                </div>
                <p v-else>
                  {{ $t("Não recebemos os dados de pagamento deste pedido.") }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-sm-6">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">{{ $t("Totais") }}</h3>
              </div>

              <div class="card-body">
                <div class="input-group">
                  <label for="subtotal">{{ $t("Subtotal") }}:</label>
                  <b-form-input id="subtotal" v-money="money" v-model="orderClone.subtotal"></b-form-input>
                </div>
                <div class="input-group">
                  <label for="shipping">{{ $t("Frete") }}:</label>
                  <b-form-input id="shipping" v-money="money" v-model="orderClone.shipping"></b-form-input>
                </div>
                <div class="input-group">
                  <label for="discount">{{ $t("Desconto") }}:</label>
                  <b-form-input id="discount" v-money="money" v-model="orderClone.discount"></b-form-input>
                </div>
                <div class="input-group">
                  <label for="tax">{{ $t("Imposto") }}:</label>
                  <b-form-input id="tax" v-money="money" v-model="orderClone.tax"></b-form-input>
                </div>
                <div class="input-group">
                  <label for="total">{{ $t("Total") }}:
                    <a v-b-tooltip.hover title="O valor Total corresponde ao Subtotal dos Itens + Frete - Desconto">
                      <i class="dropdown-icon fe fe-help-circle ml-0"></i>
                    </a>
                  </label>
                  <b-form-input id="total" v-money="money" v-model="orderClone.total"></b-form-input>
                </div>
                <div class="input-group">
                  <label for="total_paid">
                    {{ $t("Total Pago") }}:
                    <a v-b-tooltip.hover title="O valor Total Pago corresponde ao Total + Juros de Parcelamento">
                      <i class="dropdown-icon fe fe-help-circle ml-0"></i>
                    </a>
                  </label>
                  <b-form-input id="total_paid" v-money="money" v-model="orderClone.total_paid"></b-form-input>
                </div>

                <div class="input-group" v-if="orderClone.discount_description">
                  {{ orderClone.discount_description }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">{{ $t("Histórico de Status") }}</h3>
              </div>
              <div class="card-body log_history">
                <div v-if="orderClone.status_history.length > 0">
                  <b-list-group v-for="status_history in orderClone.status_history" :key="status_history._id">
                    <b-list-group-item>
                      <span class="date">{{
                        formatDate(status_history.date, locale)
                      }}</span>
                      <span class="message">{{ $t(status_history.status) }}</span>
                      <span class="app">
                        {{ $t("Aplicação que realizou esta ação") + ":" }}
                        <b>{{ getAppNameByClientID(status_history.user_client_id) }}</b>
                      </span>
                    </b-list-group-item>
                  </b-list-group>
                </div>
                <p v-else>
                  {{ $t("Não encontramos atualizações de status para este pedido.") }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">{{ $t("Logs do Pedido") }}</h3>
              </div>
              <div class="card-body log_history">
                <div v-if="orderClone.log_history.length > 0">
                  <b-list-group v-for="log_history in orderClone.log_history" :key="log_history._id">
                    <b-list-group-item>
                      <span class="date">{{ formatDate(log_history.date, locale) }}</span>
                      <span class="message">{{
                        log_history.message ? $t(log_history.message) : ""
                      }}</span>
                      <span class="app">
                        {{ $t("Aplicação que realizou esta ação") + ":" }}
                        <b>{{ getAppNameByClientID(log_history.user_client_id) }}</b>
                      </span>
                    </b-list-group-item>
                  </b-list-group>
                </div>
                <!--            <p v-else>{{ $t('Não encontramos nenhum log nesse pedido.') }}</p>-->
              </div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">{{ $t("Logs de Usuários") }}</h3>
              </div>
              <div class="card-body log_permanent">
                <div v-if="orderClone.log_permanent.length > 0">
                  <b-list-group v-for="log_permanent in orderClone.log_permanent" :key="log_permanent._id">
                    <b-list-group-item>
                      <span class="date">{{
                        formatDate(log_permanent.date, locale)
                      }}</span>
                      <span class="message">{{ log_permanent.message }}</span>
                      <span class="app">
                        {{ $t("Aplicação que realizou esta ação" + ": ") }}
                        <b>{{ getAppNameByClientID(log_permanent.user_client_id) }}</b>
                      </span>
                    </b-list-group-item>
                  </b-list-group>
                </div>
                <p v-else>
                  {{ $t("Não encontramos nenhum log nesse pedido.") }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <!-- Modal add new product -->
          <b-modal id="modalPrevent" :title="$t('Adicionar novo item ao pedido')" centered ref="modal" @ok="handleOk"
            @show="clearModalNewIten">
            <b-form @submit.stop.prevent="submitNewItem" ref="formNewItem">
              <div class="form-group">
                <b-form-input name="product_sku" :placeholder="$t('SKU do produto')" v-model.trim="newProduct.sku"
                  required></b-form-input>
                <b-form-text id="inputFormatterHelp">
                  {{ $t("Lembre-se: o") }}
                  <strong>SKU</strong>
                  {{ $t("deve ser único") }}.
                </b-form-text>
              </div>

              <div class="form-group">
                <b-form-input name="product_name" :placeholder="$t('Nome')" v-model="newProduct.name"
                  required></b-form-input>
              </div>

              <div class="form-group">
                <b-form-input name="product_price" :placeholder="$t('Preço ex: 29.99')" v-model="newProduct.price"
                  required></b-form-input>
              </div>

              <div class="form-group">
                <b-form-input name="product_quantity" :placeholder="$t('Quantidade')" v-model="newProduct.quantity"
                  required></b-form-input>
              </div>
            </b-form>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import swal from "sweetalert2";
import { VMoney } from "v-money";
import { mask } from "vue-the-mask";
import VueNumeric from "vue-numeric";
import { diff } from "deep-object-diff";
import barramento from "../../../barramento";
import { mapGetters, mapActions } from "vuex";
import NavBarActions from "./NavBarActions.vue";
import Nfe from "../../Orders_v2/Aggregates/Nfe.vue";
import StepsStatus from "../../Orders/StepsStatus.vue";
import Gnres from "../../Orders_v2/Aggregates/Gnres.vue";
import Etiqueta from "../../Orders_v2/Aggregates/Etiqueta.vue";
import DanfeA4Simplified from "../../../util/danfeA4Simplified";
import OrderShipments from "../../Orders/OrderShipments/OrderShipments.vue";

export default {
  name: "Edit",
  props: ["params"],
  directives: { mask, money: VMoney },
  components: {
    OrderShipments,
    VueNumeric,
    StepsStatus,
    NavBarActions,
    Etiqueta,
    Nfe,
    Gnres,
  },

  beforeMount() {
    this.order = this.params.item.before;
    this.order_v2 = this.params.item;
    this.apps = this.params.apps;

    this.locale = this.$root.locale;

    axios
      .get("/api/orders/apps")
      .then((response) => {
        if (response.data.length) {
          response.data.forEach((channel) => {
            if (channel.category == 2) return;

            if (
              channel.category == 1 &&
              channel.client_id == "ff7d9cb152549fb4e05bb956909742a4"
            ) {
              this.notaFiscal = true;
            }
          });
        }
      })
      .catch((error) => console.warn(error));

    const subtotal = this.formatPrice(this.orderClone.subtotal);
    const shipping = this.formatPrice(this.orderClone.shipping);
    const total_paid = this.formatPrice(this.orderClone.total_paid);
    const discount = this.formatPrice(this.orderClone.discount);
    const total = this.formatPrice(this.orderClone.total);

    this.orderClone.subtotal = subtotal;
    this.orderClone.shipping = shipping;
    this.orderClone.total_paid = total_paid;
    this.orderClone.discount = discount;
    this.orderClone.total = total;

    this.formattedFieldsOrderClone.subtotal = subtotal;
    this.formattedFieldsOrderClone.shipping = shipping;
    this.formattedFieldsOrderClone.total_paid = total_paid;
    this.formattedFieldsOrderClone.discount = discount;
    this.formattedFieldsOrderClone.total = total;

    this.orderClone.payer_phone = this.order.payer_phone;
    this.orderClone.payer_phone_area = this.order.payer_phone_area;
    this.orderClone.payer_phone2 = this.order.payer_phone2;
    this.orderClone.payer_phone2_area = this.order.payer_phone2_area;
    this.orderClone.receiver_phone = this.order.receiver_phone;

    if (this.orderClone.status_history && this.orderClone.status_history.length) {
      this.orderClone.status_history = this.orderClone.status_history.sort((a, b) =>
        moment(b.date).diff(moment(a.date))
      );
    }

    if (this.orderClone.log_history && this.orderClone.log_history.length) {
      this.orderClone.log_history = this.orderClone.log_history.sort((a, b) =>
        moment(b.date).diff(moment(a.date))
      );
    }

    if (this.orderClone.log_permanent && this.orderClone.log_permanent.length) {
      this.orderClone.log_permanent = this.orderClone.log_permanent.sort((a, b) =>
        moment(b.date).diff(moment(a.date))
      );
    }
  },
  data() {
    return {
      apps: [],
      locale: null,
      notaFiscal: false,
      order: [],
      order_v2: [],
      showAddressShipping: true,
      toggleLoadingActionsV: false,
      localeMap: {
        'pt': 'pt-BR',
        'br': 'pt-BR',
        'es': 'es-ES',
        'US': 'en-US',
        'pt_BR': 'pt-BR'
      },
      fields: [
        { key: "sku", label: "SKU" },
        { key: "name", label: "Nome" },
        { key: "price", label: "Preço" },
        { key: "quantity", label: "Quantidade" },
        { key: "discount", label: "Desconto" },
        { key: "commission.total_charged", label: "Comissão" },
        { key: "total", label: "Total" },
      ],
      stock_code_show: false,
      place_code_show: false,
      editingItems: {},
      money: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },

      newProduct: {
        sku: null,
        name: null,
        price: null,
        quantity: null,
        total: 0,
      },

      orderClone: _.cloneDeep(this.params.item.before),

      formattedFieldsOrderClone: _.cloneDeep(this.params.item.before),

      teste: this.$store.state.showorder,

      exportAlert: {
        show: false,
        path: "",
      },

      statusOptions: {
        pending: "Pendente",
        paid: "Pago",
        approved: "Aprovado",
        partial_payment: "Pagamento parcial",
        shipping_informed: "Entrega informada",
        waiting_invoice: "Nota fiscal solicitada",
        invoice_error: "Erro ao gerar nota fiscal",
        shipped: "Em Trânsito",
        shipping_error: "Erro ao enviar entrega",
        delivered: "Recebido",
        canceled: "Cancelado",
        under_review: "Sob análise",
      },
    };
  },

  computed: {
    ...mapGetters({
      user: "getUserObject",
    }),
    hasPermissionToEdit() {
      const subuser = this.user.pluggToSubuser;
      const permissions = subuser ? subuser.permissions : null;

      const has = !(
        subuser &&
        permissions &&
        !permissions.find((x) => x === "core.writeOrders")
      );
      return has;
    },
  },

  methods: {
    ...mapActions({
      addNewItem: "addNewItem",
      updateOrder: "updateOrder",
      showOrderLogs: "showOrderLogs",
      removeCurrentOrder: "removeCurrentOrder",
    }),
    itemKey(item) {
      const base = item.sku;
      const variation = item.variation && item.variation.sku ? item.variation.sku : null;
      return variation ? `${base}-${variation}` : base;
    },
    editItem(item) {
      const key = this.itemKey(item);
      this.$set(this.editingItems, key, {
        sku: item.sku,
        variation_sku: item.variation ? item.variation.sku : '',
      });
    },
    async saveEditItem(item) {
      const ok = await swal({
        title: 'Deseja continuar?',
        type: 'warning',
        text: 'Tem certeza que deseja salvar as alterações no(s) sku(s) do pedido?.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Salvar',
      }).then((ok) => ok.value);

      if (!ok) return;

      const key = this.itemKey(item);
      const editing = this.editingItems[key];
      const payload = {
        order_id: this.order.id,
        old: item.sku,
        new: editing.sku,
      };

      payload.old_variation_sku = null;
      payload.new_variation_sku = null;
      if (item.variation && item.variation.sku) {
        payload.old_variation_sku = item.variation.sku;
        payload.new_variation_sku = editing.variation_sku;
      }

      this.$http
        .post('/api/orders/updatesku', payload)
        .then((response) => {
          item.sku = editing.sku;
          if (item.variation && item.variation.sku !== undefined) {
            this.$set(item.variation, 'sku', editing.variation_sku);
          }
          this.$delete(this.editingItems, key);
          swal('Pronto!', this.$t(response.data.message), 'success');
        })
        .catch(() => {
          this.$delete(this.editingItems, key);
          swal(
            'Ops!',
            this.$t('Não foi possivel alterar o sku deste pedido, tente novamente em alguns instantes.'),
            'warning'
          );
        });
    },
    closeEdit() {
      barramento.$emit("order_edit_close");
    },
    stockCodeShow(stock_code) {
      if (!!stock_code)
        this.stock_code_show = true;
      return stock_code;
    },
    placeCodeShow(place_code) {
      if (!!place_code)
        this.place_code_show = true;
      return place_code;
    },
    parseDocumentCNPJ(orderClone) {
      if (orderClone.payer_document)
        if (orderClone.payer_document.length >= 14)
          return true;
      return false;
    },
    getAppNameByClientID(clientID) {
      if (clientID == "6e19e8b91aa41d1911cf24ef4ae265e7") {
        return "Painel de Pedidos";
      }
      for (var i in this.apps) {
        if (this.apps[i].client_id == clientID) {
          return this.apps[i].name;
        }
      }
      return clientID;
    },
    editPermissionErrorAlert() {
      swal({
        title: "Ops!",
        text: this.$t("Você não possui permissão para editar pedidos."),
        type: "error",
        closeOnConfirm: false,
        closeOnCancel: false,
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: true,
      });
    },
    formatDate(value, loc) {
      if (value) {
        const date = new Date(String(value));
        const locale = this.localeMap[loc] || 'pt-BR';

        const options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
          timeZone: 'America/Sao_Paulo' // Adjust timezone as needed
        };

        return date.toLocaleString(locale, options);
      }
    },

    formatDateDelivery: function (value, loc, show_time = false) {
      if (value) {
        const date = new Date(String(value));
        const locale = this.localeMap[loc] || 'pt-BR';
        const options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          timeZone: 'America/Sao_Paulo' // Adjust timezone as needed
        };

        if (show_time) {
          options.hour = '2-digit';
          options.minute = '2-digit';
          options.second = '2-digit';
        }

        return date.toLocaleString(locale, options);
      }
    },

    capitalizeFirstLetter(string) {
      if (string && string.length) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
    },

    formatCurrency(value, loc) {
      if (loc == "US") {
        return Intl.NumberFormat("en-US", {
          currency: "USD",
          style: "currency",
          minimumFractionDigits: 2,
        }).format(value);
      } else if (loc == "AR") {
        return Intl.NumberFormat("es-ar", {
          currency: "ARS",
          style: "currency",
          minimumFractionDigits: 2,
        }).format(value);
      } else {
        return Intl.NumberFormat("pt-br", {
          currency: "BRL",
          style: "currency",
          minimumFractionDigits: 2,
        }).format(value);
      }
    },

    checkIfOrderHasChanges(orders) {
      const hasChanges = Object.keys(orders).reduce((key) =>
        ["log_permanent", "event", "log_history", "order_id"].includes(key)
      );

      if (hasChanges) {
        swal({
          title: "Ops!",
          text: this.$t("Não há nenhuma alteração no pedido."),
          type: "error",
          closeOnConfirm: false,
          closeOnCancel: false,
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: true,
        });
      }

      return hasChanges;
    },
    canceledOrder() {
      this.order_v2.before_status = "canceled";
    },
    save(event) {
      event.target.setAttribute("disabled", true);

      if (!this.hasPermissionToEdit) {
        this.editPermissionErrorAlert();
        return;
      }

      Object.size = function (obj) {
        var size = 0;
        var key;
        for (key in obj) {
          //if (obj.hasOwnProperty(key))
          size++;
        }
        return size;
      };

      let differenceBetweenObj = diff(this.formattedFieldsOrderClone, this.orderClone);

      if (this.checkIfOrderHasChanges(differenceBetweenObj)) {
        event.target.removeAttribute("disabled");
        return;
      }

      if (Object.size(differenceBetweenObj) === 0) {
        swal({
          title: "Ops",
          text: this.$t("Nenhuma alteração foi encontrada para ser salva!"),
          type: "info",
        });
        event.target.removeAttribute("disabled");
        return;
      }

      this.updateOrder({
        order_id: this.order.id,
        ...differenceBetweenObj,
        event: event,
      });
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    addNewShipping() {
      /*this.$store.commit("ADD_NEW_SHIPMENT_ORDER", {
        shipping_company: "",
        id: Math.random().toString(36).substr(2, 5), // Gera um novo ID provisório para conseguir encontra-lo mais tarde.
      });*/
      this.order.shipments.push({
        shipping_company: "",
        id: Math.random().toString(36).substr(2, 5), // Gera um novo ID provisório para conseguir encontra-lo mais tarde.
      });
    },

    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();
      let form = this.$refs.formNewItem;

      let hasEmptyField = 0;
      let fields = form.querySelectorAll("input");

      fields.forEach((element) => {
        if (!element.value.length) {
          hasEmptyField++;
          element.classList.add("is-invalid");
        } else {
          element.classList.remove("is-invalid");
          element.classList.add("is-valid");
        }
      });

      if (!hasEmptyField) {
        this.submitNewItem();
      }
    },

    toggleLoadingActions() {
      this.toggleLoadingActionsV = !this.toggleLoadingActionsV;
      barramento.$emit("orders_load_nav_bar2", this.toggleLoadingActionsV);
    },

    generatePDF() {
      barramento.$emit("orders_load_nav_bar2", true);

      let data = {
        filtered: false,
        type: "pdf",
        ids: [this.orderClone.id],
      };

      data.compactPdf = false;

      axios
        .post("/api/orders/export/selecionados", data)
        .then((success) => {
          barramento.$emit("orders_load_nav_bar2", false);
          /*let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();*/
          swal({
            title: this.$t("Pronto!"),
            text: this.$t("Exportação inserida na fila com sucesso!"),
            type: "success",
          });
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: error,
            type: "error",
          });
          barramento.$emit("orders_load_nav_bar2", false);
        });
    },

    processing_picking() {
      this.changeStatus("picking", "processing_picking", false);
    },

    changeStatus(status, sub_status, show_modal) {
      let ids = [
        {
          id: this.order.id,
          status: status,
          sub_status: sub_status,
        },
      ];
      this.toggleLoadingActions();
      this.$http
        .post("/api/orders/updatestatus", ids)
        .then((response) => {
          let ids = response.data.join(", ");
          if (response.data.length) {
            if (show_modal == true) {
              swal(
                "Ops",
                this.$t(
                  "Não foi possivel alterar o status deste pedido, tente novamente em alguns instantes."
                ),
                "warning"
              );
            }
            this.toggleLoadingActions();
            return;
          }
          if (show_modal == true) {
            swal(
              "Pronto!",
              this.$t("O status do pedido foi alterado com sucesso!"),
              "success"
            );
          }
          if (status == "picking" && sub_status == "processing_picking") {
            //gera o PDF
            this.exportPicking();
          } else {
            this.$router.push({ name: "dashboard" });
          }
          this.toggleLoadingActions();
        })
        .catch((error) => {
          swal(
            "Ops!",
            this.$t(
              "Não foi possivel alterar o status deste pedido, tente novamente em alguns instantes."
            ),
            "warning"
          );
          this.toggleLoadingActions();
        });
    },

    exportPicking() {
      //this.toggleLoadingActions();

      let data = {
        filtered: false,
        type: "picking",
        ids: this.orderClone,
      };

      data.ids = this.orderClone;

      axios
        .post("/api/orders/export/picking", data)
        .then((success) => {
          let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t("Lista de picking gerada com sucesso!"),
            type: "success",
          });
          //this.toggleLoadingActions();
          /*this.cleanActionList();
          this.loadTotalOrders();
          this.applyFilter();*/
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Não foi possivel gerar a lista de picking, tente novamente em alguns instantes."
            ),
          });
          //this.toggleLoadingActions();
        });
    },

    sigep(status, sub_status, show_modal) {
      let ids = [
        {
          id: this.order.id,
        },
      ];
      this.toggleLoadingActions();
      this.$http
        .post("/api/orders/sigep", ids)
        .then((response) => {
          let ids = response.data.join(", ");
          if (response.data.length) {
            if (show_modal == true) {
              swal(
                "Ops",
                this.$t(
                  "Não foi possivel alterar o status deste pedido, tente novamente em alguns instantes."
                ),
                "warning"
              );
            }
            this.toggleLoadingActions();
            return;
          }
          if (show_modal == true) {
            swal(
              "Pronto!",
              this.$t("O status do pedido foi alterado com sucesso!"),
              "success"
            );
          }

          this.toggleLoadingActions();
        })
        .catch((error) => {
          swal(
            "Ops!",
            this.$t(
              "Não foi possivel alterar o método de envio, tente novamente em alguns instantes."
            ),
            "warning"
          );
          this.toggleLoadingActions();
        });
    },

    submitNewItem() {
      let item = {
        order_id: this.order.id,
        item: this.newProduct,
      };

      this.addNewItem(item);
      this.$refs.modal.hide();
    },

    clearModalNewIten() {
      this.newProduct.sku = null;
      this.newProduct.name = null;
      this.newProduct.price = null;
      this.newProduct.quantity = null;
    },

    print(tag, key, shipment, order_id) {
      var order = [order_id];
      if (tag == "has_label") {
        //chama impressão de etiqueta
        this.print_labels(order, true);
      } else {
        //outros documentos
        if (key == null || key == 0) {
          swal({
            title: "Ops!",
            text: this.$t("Este pedido não possui este documento gerado pelo sistema"),
          });
        } else {
          var id = [
            {
              id: order_id,
              shipments: shipment,
            },
          ];

          if (tag == "has_invoice_doc") {
            this.print_nfes(id, true);
          }

          if (tag == "has_gnre_doc") {
            this.print_gnres(id, true);
          }
        }
      }
      barramento.$emit("orders_load_nav_bar2", false);
    },
    print_nfes(orders_ids, show_modal) {
      this.toggleLoadingActions();
      axios
        .post("/api/documents/get_nfes", orders_ids)
        .then((response) => {
          if (response.data.erro) {
            if (show_modal == true) {
              swal({
                title: "Ops!",
                text: response.data.erro,
                type: "error",
              });
            }
          } else {
            let link = document.createElement("a");
            link.setAttribute("href", response.data.file);
            link.setAttribute("download", response.data.file);
            link.setAttribute("target", "_blank");
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.toggleLoadingActions();
            if (show_modal == true) {
              swal({
                title: this.$t("Pronto!"),
                text: this.$t("Notas fiscais geradas com sucesso!"),
                type: "success",
              });
            }
          }
        })
        .catch((error) => {
          this.toggleLoadingActions();
          swal({
            title: "Ops!",
            text: this.$t(
              "Ocorreu algum problema ao tentar gerar as notas fiscais, tente novamente em alguns instantes."
            ),
            type: "error",
          });
        });
    },

    print_gnres(orders_ids, show_modal) {
      this.toggleLoadingActions();
      axios
        .post("/api/documents/get_gnres", orders_ids)
        .then((response) => {
          if (response.data.erro) {
            if (show_modal == true) {
              swal({
                title: "Ops!",
                text: this.$t("Nenhuma GNRE encontrada"),
                type: "error",
              });
            }
          } else {
            let link = document.createElement("a");
            link.setAttribute("href", response.data.file);
            link.setAttribute("download", response.data.file);
            link.setAttribute("target", "_blank");
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.toggleLoadingActions();
            if (show_modal == true) {
              swal({
                title: this.$t("Pronto!"),
                text: this.$t("GNREs geradas com sucesso!"),
                type: "success",
              });
            }
          }
        })
        .catch((error) => {
          this.toggleLoadingActions();
          swal({
            title: "Ops!",
            text: this.$t(
              "Ocorreu algum problema ao tentar gerar as GNREs, tente novamente em alguns instantes."
            ),
            type: "error",
          });
        });
    },

    print_labels(orders_ids, show_modal, endpoint = "/api/documents/get_labels") {
      barramento.$emit("orders_load_nav_bar2", true);
      axios
        .post(endpoint, orders_ids)
        .then((response) => {
          if (response.data.urls) {
            response.data.urls.forEach(function (pdf_link) {
              if (pdf_link != null) {
                var type = pdf_link.substr(pdf_link.length - 3);
                let link = document.createElement("a");
                link.setAttribute("href", pdf_link);
                link.setAttribute("target", "_blank");
                if (type == "zpl") {
                  link.setAttribute("download", "etiqueta.zpl");
                  link.href = window.URL.createObjectURL(new Blob([pdf_link], { type }));
                } else {
                  link.setAttribute("download", pdf_link);
                }

                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
              }
            });
            if (show_modal == true) {
              swal({
                title: this.$t("Pronto!"),
                text: this.$t("Etiquetas geradas com sucesso!"),
                type: "success",
              });
            }
            barramento.$emit("orders_load_nav_bar2", false);
          } else {
            if (show_modal == true) {
              if (response.data.error) {
                if (response.data.error.orders) {
                  var text = this.$t(
                    "Ocorreu algum problema ao tentar gerar as etiquetas do(s) pedido(s)"
                  );

                  for (var key in response.data.error.orders) {
                    text = text + "<br><br>" + this.$t("Pedido") + " " + key;
                    for (var key2 in response.data.error.orders[key]) {
                      text = text + "<br>" + response.data.error.orders[key][key2];
                    }
                  }
                }

                if (response.data.error.config) {
                  var text = this.$t(
                    "Ocorreu algum problema ao tentar gerar as etiquetas"
                  );

                  text =
                    text +
                    "<br><br>" +
                    this.$t("Clique") +
                    ' <a href="http://beta.plugg.to/settings#labels" target="_parent">' +
                    this.$t("aqui") +
                    " <a> " +
                    this.$t("para configurar o formato de impressão") +
                    ".";
                }

                swal({
                  title: "Ops!",
                  html: text,
                  type: "error",
                });
              } else {
                swal({
                  title: this.$t("Pronto!"),
                  text: this.$t("Etiquetas geradas com sucesso!"),
                  type: "success",
                });
              }
            }
            barramento.$emit("orders_load_nav_bar2", false);
          }
        })
        .catch((error) => {
          barramento.$emit("orders_load_nav_bar2", false);
          let message = "Etiqueta não está disponivel";
          if (
            error.response &&
            (typeof error.response.data === "string" ||
              error.response.data instanceof String)
          ) {
            message = error.response.data;
          }
          swal({
            title: "Ops!",
            html: message,
            type: "error",
          });
        });
    },

    print_all(order) {
      var id = [
        {
          id: order.id,
          shipments: order.shipments,
        },
      ];
      this.print_labels([order.id], false);
      this.print_nfes(id, false);
      this.print_gnres(id, false);
    },
    print_danfe_all() {
      barramento.$emit("orders_load_nav_bar2", true);
      DanfeA4Simplified.printDanfA4Simplificada(this.order_v2, false);
    },

    hasBuffered() {
      let haveBuffered = false;

      for (let key in this.order.shipments) {
        const shipment = this.order.shipments[key];
        if (shipment.status == "buffered" && shipment.buffering_date) {
            haveBuffered = true;
        }
      }
      return haveBuffered;
    },

    getDateBuffered() {
      let data = null;

      for (let key in this.order.shipments) {
        const shipment = this.order.shipments[key];
        if (shipment.status == "buffered" && shipment.buffering_date) {
          data = shipment.buffering_date;
        }
      }

      if (data)  {
        if (this.locale != "US") {
          return moment(String(data)).format("DD/MM/YYYY");
        } else {
          return moment(String(data)).format("YYYY-MM-DD");
        }
      }

      return '';
    }
  },
  beforeDestroy() {
    barramento.$off("edit_generate_labels");
    barramento.$off("edit_exportar_pdf");
    barramento.$off("edit_enviar_porsigep_web");
    barramento.$off("edit_marcar_como_separado");
    barramento.$off("edit_gerar_nota_fiscal");
    barramento.$off("edit_imprimir_lista_de_picking");
    barramento.$off("edit_imprimir_notas_fiscais");
    barramento.$off("edit_imprimir_tudo");
    barramento.$off("edit_imprimir_gnre");
    barramento.$off("edit_print_danfe_all");
    barramento.$off("edit_imprimir_etiquetas");
    barramento.$off("edit_marcar_como_embalado");
    barramento.$off("edit_marcar_como_enviado");
    barramento.$off("edit_marcar_como_entregue");
    barramento.$off("edit_marcar_como_cancelado");
    barramento.$off("edit_atualizar_depois_de_gerar_os_arquivos");
  },
  created() {
    barramento.$on("edit_generate_labels", () => {
      this.print_labels([this.orderClone.id], false, "/api/documents/make_label");
    });
    barramento.$on("edit_exportar_pdf", () => {
      this.generatePDF();
    });
    barramento.$on("edit_enviar_porsigep_web", () => {
      this.sigep(true);
    });
    barramento.$on("edit_marcar_como_separado", () => {
      this.changeStatus("picking", "pending_invoice", true);
    });
    barramento.$on("edit_gerar_nota_fiscal", () => {
      this.changeStatus("waiting_invoice", "waiting_invoice", true);
    });
    barramento.$on("edit_imprimir_lista_de_picking", () => {
      this.processing_picking();
    });
    barramento.$on("edit_imprimir_notas_fiscais", () => {
      this.print("has_invoice_doc", "1", this.order.shipments, this.order.id);
    });
    barramento.$on("edit_imprimir_tudo", () => {
      this.print_all(this.order);
    });
    barramento.$on("edit_imprimir_gnre", () => {
      this.print("has_gnre_doc", "1", this.order.shipments, this.order.id);
    });
    barramento.$on("edit_imprimir_etiquetas", () => {
      this.print("has_label", "1", this.order.shipments, this.order.id);
    });
    barramento.$on("edit_marcar_como_embalado", () => {
      this.changeStatus("invoiced", "processing_expedition", true);
    });
    barramento.$on("edit_marcar_como_enviado", () => {
      this.changeStatus("shipping_informed", "dispatched", true);
    });
    barramento.$on("edit_marcar_como_entregue", () => {
      this.changeStatus("delivered", null, true);
    });
    barramento.$on("edit_atualizar_depois_de_gerar_os_arquivos", (obj) => {
      this.order_v2 = obj;
    });

    barramento.$on("edit_marcar_como_cancelado", () => {
      this.changeStatus("canceled", null, true);
    });

    barramento.$on("edit_print_danfe_all", () => {
      barramento.$emit("orders_load_nav_bar2", true);
      this.print_danfe_all();
    });
  },
};
</script>

<style scoped>
.log-item {
  margin: 0.5rem 0 !important;
}

.input-group label {
  width: 1000%;
}

.input-group {
  margin-bottom: 15px;
}

.show-order-header {
  margin-top: 15px;
}

.log_history .date,
.log_permanent .date {
  font-size: 0.8rem;
  display: block;
  font-weight: bold;
}

.log_history .message,
.log_permanent .message {
  font-size: 1rem;
  display: block;
}

.log_history .app,
.log_permanent .app {
  font-size: 0.8rem;
  display: block;
}

.teste {
  display: none;
}

.list-group .list-group-item {
  border-radius: 0;
}

.list-group:first-of-type .list-group-item {
  border-radius: 3px 3px 0 0;
}

.list-group:last-of-type .list-group-item {
  border-radius: 0 0 3px 3px;
}

.hide-button {
  display: none;
}

.show-button {
  display:block;
}

.sku-edit-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.sku-edit-grid.single {
  grid-template-columns: 1fr;
}

.sku-edit-field {
  min-width: 0;
}

.items-table-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.items-table {
  min-width: 860px;
}

@media (max-width: 768px) {
  .sku-edit-grid {
    grid-template-columns: 1fr;
  }
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Edit.vue